<ng-container *ngIf="accents.length; else empty">
    <stats-pie-chart [options]="options"></stats-pie-chart>

    <div class="metrics-details-container">
        <app-metrics-item *ngFor="let accent of accents"
                          [title]="accent.name"
                          [backgroundColors]="[accent.color]"
                          [mainMetricValue]="((accent.occurrence / accent.totalOccurrence) | percent:'1.0-1') ?? ''"
                          [mainMetricUnit]="''"
                          [legend]="accent.occurrence + ' x'">
        </app-metrics-item>
    </div>
</ng-container>

<ng-template #empty>
    <app-stats-empty *ngIf="loaded"></app-stats-empty>
</ng-template>
